import { useState } from "react";
import "../styles/DesignPortfolio.css";

const projectsData = [
  {
    id: 1,
    title: "Upcycled Denim Utility Vest",
    category: "Sustainable",
    year: "2023",
    mainImage: "/project1/mainimage.png",
    detailMedia: [
      {
        type: "video",
        url: "/project1/video1.mp4",
        thumbnail: "/project1/thumbnail3.png",
      },
      {
        type: "video",
        url: "/project1/video2.mp4",
        thumbnail: "/project1/thumbnail4.png",
      },
      {
        type: "video",
        url: "/project1/video3.mp4",
        thumbnail: "/project1/thumbnail6.png",
      },
    ],

    description:
      "A transformative piece that reimagines vintage denim into a modern utility vest, featuring multiple functional pockets and Carhartt tested denim.",
    materials: "Repurposed vintage denim and antique brass hardware",
    process:
      "Each vest is carefully deconstructed from vintage denim pieces, reinforced at stress points, and reconstructed with attention to both functionality and style.",
    details: [
      "One large zipped pocket in the back",
      "Two original functional pockets",
      "Reinforced stitching at stress points",
      "Antique brass hardware",
    ],
  },
  {
    id: 2,
    title: "Technical Cargo Pants with Matching Top",
    category: "Custom",
    year: "2024",
    mainImage: "/project2/mainimage.png",
    detailMedia: [
      {
        type: "image",
        url: "/project2/image1.jpg",
        alt: "Technical cargo pants detail",
      },
      {
        type: "image",
        url: "/project2/image2.jpg",
        alt: "Technical cargo pants detail",
      },
      {
        type: "image",
        url: "/project2/image3.jpg",
        alt: "Technical cargo pants detail",
      },
    ],
    description:
      "A technical approach to cargo pants that combines functionality with refined tailoring and innovative pocket designs.",
    materials: "Nylon Tafata, YKK AquaGuard zippers, mil-spec webbing",
    process:
      "Developed through extensive prototyping to perfect the balance between utility features and clean lines, with particular attention to pocket placement and leg articulation.",
    details: [
      "Articulated knee construction",
      "Adjustable ankle closure",
      "Cargo Pockets",
    ],
  },
  {
    id: 3,
    title: "Reconstructed Knitwear Piece",
    category: "Sustainable",
    year: "2024",
    mainImage: "/project3/mainimage.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project3/image1.jpg",
        alt: "Knitwear construction detail",
      },
      {
        type: "video",
        url: "/project3/video1.mp4",
        thumbnail: "/project3/thumbnail1.jpg",
      },
      {
        type: "video",
        url: "/project3/video3.mp4",
        thumbnail: "/project3/thumbnail3.jpg",
      },
      {
        type: "video",
        url: "/project3/video5.mp4",
        thumbnail: "/project3/thumbnail5.jpg",
      },
    ],
    description:
      "A modern interpretation of traditional knitwear, created from carefully selected vintage knit blanket and reconstructed into a new silhouette.",
    materials: "Knitted Blankey",
    process:
      "Each piece is carefully deconstructed and reimagined, preserving the quality of original materials while creating entirely new forms.",
    details: [
      "Mixed knit patterns",
      "Seamless integration techniques",
      "Zero Fabric Waste",
      "Custom fit adjustments",
    ],
  },
  {
    id: 4,
    title: "Reconstructed Quilted Piece",
    category: "Sustainable",
    year: "2022",
    mainImage: "/project4/mainimage.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project4/image1.jpg",
        alt: "Quilting detail",
      },
      {
        type: "image",
        url: "/project4/image2.png",
        alt: "Quilting detail",
      },
      {
        type: "video",
        url: "/project4/video1.mp4",
        thumbnail: "/project4/mainimage.jpg",
      },
      {
        type: "image",
        url: "/project4/image3.jpg",
        alt: "Quilting detail",
      },
      {
        type: "image",
        url: "/project4/image4.png",
        alt: "Quilting detail",
      },
      {
        type: "video",
        url: "/project4/video2.mp4",
        thumbnail: "/project4/mainimage.jpg",
      },
    ],
    description:
      "A modern interpretation of 2pc set, created from carefully selected upcycled pieces and reconstructed into a new silhouette.",
    materials: "Cotton quilted comforter",
    process:
      "Each piece is carefully deconstructed and reimagined, preserving the quality of original materials while creating entirely new forms.",
    details: ["Custom fit adjustments"],
  },
  {
    id: 5,
    title: "Custom Waffle 2pc Set",
    category: "Custom",
    year: "2023",
    mainImage: "/project5/mainimage.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project5/image1.jpg",
        alt: "Waffle texture detail",
      },
      {
        type: "video",
        url: "/project5/video1.MOV",
        thumbnail: "/project5/thumbnail1.jpg",
      },
      {
        type: "image",
        url: "/project5/image2.jpg",
        alt: "Waffle texture detail",
      },
      {
        type: "video",
        url: "/project5/video2.MOV",
        thumbnail: "/project5/thumbnail2.jpg",
      },
      {
        type: "video",
        url: "/project5/video3.MOV",
        thumbnail: "/project5/thumbnail3.jpg",
      },
    ],
    description:
      "A contemporary take on loungewear, featuring a cropped boxy top and relaxed shorts crafted in luxurious Turkish waffle cotton. The set combines comfort with elevated details for a refined casual aesthetic.",
    materials:
      "Premium Turkish waffle cotton, YKK gold quarter-zip hardware, ribbed trim detailing",
    process:
      "Each piece is cut and constructed to achieve the perfect boxy silhouette. Special attention was paid to the crop length and shorts inseam to create a balanced, modern proportion.",
    details: [
      "Quarter-zip closure with gold hardware",
      "Cropped boxy top with ribbed hem",
      "Relaxed-fit shorts with elastic waistband",
      "Textured waffle cotton construction",
      "Comfortable lounge fit with elevated details",
    ],
  },
  {
    id: 6,
    title: "Custom Denim Combbe Jacket",
    category: "Custom",
    year: "2024",
    mainImage: "/project6/mainimage.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project6/image1.jpg",
        alt: "Jacket construction detail",
      },
      {
        type: "video",
        url: "/project6/video1.MOV",
        thumbnail: "/project6/thumbnail1.jpg",
      },
      {
        type: "video",
        url: "/project6/video2.MOV",
        thumbnail: "/project6/thumbnail2.jpg",
      },
      {
        type: "video",
        url: "/project6/video3.MOV",
        thumbnail: "/project6/thumbnail3.jpg",
      },
    ],
    description:
      "A contemporary interpretation of the traditional Japanese noragi jacket, crafted in lightweight denim. The Combbe jacket features clean lines and thoughtful construction, blending Eastern silhouettes with modern workwear sensibilities.",
    materials:
      "Lightweight denim fabric, contrast stitching, traditional wrap closure system",
    process:
      "Each panel is carefully cut and constructed to achieve the perfect drape in lightweight denim. The design incorporates traditional Japanese garment elements while adapting the construction techniques for modern denim workwear.",
    details: [
      "Wrapped front closure design",
      "Lightweight denim construction",
      "Traditional inspired sleeve shape",
      "Reinforced stress points",
      "Customized fit and proportions",
      "Clean finished interior seams",
    ],
  },
  {
    id: 7,
    title: "Repurposed Thrifted Hockey Jersey",
    category: "Sustainable",
    year: "2022",
    mainImage: "/project7/image1.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project7/image1.jpg",
        alt: "Repurposed Jersey",
      },
      {
        type: "video",
        url: "/project7/video1.MOV",
        thumbnail: "/project7/thumbnail1.jpg",
      },
      {
        type: "video",
        url: "/project7/video2.MOV",
        thumbnail: "/project7/thumbnail2.jpg",
      },
      {
        type: "video",
        url: "/project7/video3.MOV",
        thumbnail: "/project7/thumbnail3.jpg",
      },
    ],
    description:
      "A reimagined thrifted hockey jersey transformed into a unique brand piece. This upcycled design combines vintage sportswear with modern vinyl applications to create a one-of-a-kind statement piece.",
    materials:
      "Vintage hockey jersey, custom vinyl applications, original jersey mesh construction",
    process:
      "Starting with a blank thrifted hockey jersey, each vinyl element was carefully designed and placed to create a balanced composition. The jersey maintains its authentic athletic construction while gaining a new identity through strategic vinyl placement.",
    details: [
      "Original mesh jersey construction",
      "Custom vinyl number placement",
      "Preserved athletic detailing",
      "Brand logo integration",
      "Authentic hockey jersey fit",
    ],
  },
  {
    id: 8,
    title: "Thrifted and Collaborated Vest & Jeans",
    category: "Sustainable",
    year: "2024",
    mainImage: "/project8/mainimage.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project8/image1.jpg",
        alt: "Original Vest",
      },
      {
        type: "video",
        url: "/project8/video1.mov",
        thumbnail: "/project8/thumbnail1.jpg",
      },
      {
        type: "video",
        url: "/project8/video2.mov",
        thumbnail: "/project8/thumbnail2.jpg",
      },
    ],
    description:
      "A powerful fusion of vintage workwear and artistic expression, this collaborative set transforms a thrifted bulletproof vest and Carhartt jeans into a canvas for Detroit-based artist Terry Childress. The pieces feature his signature futuristic Afrocentric combat woman artwork, bridging utility, streetwear, and fine art.",
    materials:
      "Vintage bulletproof vest, authentic Carhartt denim, custom screen printing, blue zipper hardware",
    process:
      "Sourced from Detroit thrift stores, these pieces were carefully selected for their unique character. The collaboration with local artist Terry Childress adds a layer of storytelling through his distinctive screen-printed artwork, while maintaining the rugged authenticity of the original pieces.",
    details: [
      "Dual side-zip vest openings with blue hardware",
      "Original Carhartt denim construction",
      "Custom screen-printed artwork by Terry Childress",
      "Preserved bulletproof vest structure",
      "One-of-one collaborative artwork placement",
      "Authentic Detroit-sourced materials",
    ],
  },
  {
    id: 9,
    title: "Crown Royal Balaclava",
    category: "Sustainable",
    year: "2025",
    mainImage: "/project9/mainimage.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project9/image1.jpg",
        alt: "Crown Royal Balaclava front view",
      },
      {
        type: "image",
        url: "/project9/image2.jpg",
        alt: "Crown Royal Balaclava side view",
      },
      {
        type: "video",
        url: "/project9/video1.mp4",
        thumbnail: "/project9/thumbnail1.png",
      },
    ],
    description:
      "An innovative upcycled accessory created from repurposed Crown Royal bags. This balaclava combines street style with sustainable design practices, transforming iconic purple fabric bags into a distinctive head covering.",
    materials: "Upcycled Crown Royal fabric bags, satin lining",
    process:
      "Multiple Crown Royal bags were carefully deconstructed and pieced together to create a sustainable pattern that maintains the recognizable purple fabric and gold detailing. Each piece is reinforced at stress points and lined for comfort and durability.",
    details: [
      "Preserved Crown Royal logo and gold drawstring elements",
      "Adjustable face opening",
      "Comfortable satin lining",
      "Reinforced stitching at stress points",
      "Each piece unique due to bag variations",
      "Zero-waste construction using entire bags",
    ],
  },
  {
    id: 10,
    title: "Upcycled Comforter Vest",
    category: "Sustainable",
    year: "2025",
    mainImage: "/project10/mainimage.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project10/image1.jpg",
        alt: "Comforter Vest front view",
      },
      {
        type: "video",
        url: "/project10/video1.mp4",
        thumbnail: "/project10/thumbnail1.png",
      },
      {
        type: "image",
        url: "/project10/image2.jpg",
        alt: "Comforter Vest detail view",
      },
    ],
    description:
      "A luxuriously comfortable vest reimagined from a vintage quilted comforter. This piece combines the tactile comfort of bedding with functional outerwear design, creating a unique layering piece that blends nostalgia with contemporary silhouettes.",
    materials: "Vintage quilted comforter, custom hardware, reinforced binding",
    process:
      "The original comforter was carefully selected for its unique pattern and quality construction. It was then professionally cleaned and deconstructed, maintaining the original quilting pattern while reshaping it into a structured vest form with reinforced edges.",
    details: [
      "Preserved original quilting pattern",
      "Custom closure system",
      "Reinforced binding at all edges",
      "Two functional front pockets",
      "Adjustable back panel for fit customization",
      "Unique color story based on original comforter design",
    ],
  },
  {
    id: 11,
    title: "Quilted & Jacquard Mix Media Vest",
    category: "Sustainable",
    year: "2025",
    mainImage: "/project11/mainimage.jpg",
    detailMedia: [
      {
        type: "image",
        url: "/project11/image1.jpg",
        alt: "Quilted and jacquard vest front view",
      },
      {
        type: "image",
        url: "/project11/image2.jpg",
        alt: "Quilted and jacquard vest back view",
      },
      {
        type: "image",
        url: "/project11/image3.jpg",
        alt: "Quilted and jacquard vest lining detail",
      },
    ],
    description:
      "A bold, contrasting vest that combines vibrant red quilted material with luxurious black satin jacquard. This piece features a sleek silhouette with thoughtful construction details and a custom Both Rows QR code integrated into the lining.",
    materials:
      "Red quilted material, black satin jacquard, black bias tape, rubberized vinyl print, custom QR code lining",
    process:
      "This vest was created by utilizing leftover premium materials from other projects, combining them in a harmonious design that highlights the textural contrast between quilted surfaces and smooth jacquard. The design incorporates precise vinyl application for branding elements and a specialty printed lining featuring the Both Rows QR code.",
    details: [
      "Contrasting material panels with clean transitions",
      "Reinforced bias tape edging for structure and durability",
      "Custom vinyl branding elements",
      "Signature Both Rows QR code integrated into satin lining",
      "Zero-waste construction using leftover premium materials",
      "Tailored fit with strategic panel placement",
    ],
  },
];

const DesignPortfolio = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [expandedProjects, setExpandedProjects] = useState({});
  const categories = ["All", "Sustainable", "Custom"];

  const filteredProjects =
    selectedCategory === "All"
      ? projectsData
      : projectsData.filter((project) => project.category === selectedCategory);

  const toggleProjectExpansion = (projectId) => {
    setExpandedProjects(prev => ({
      ...prev,
      [projectId]: !prev[projectId]
    }));
  };

  const MediaItem = ({ item, projectTitle, index }) => {
    if (item.type === "video") {
      const extension = item.url.split(".").pop().toLowerCase();
      const videoType = extension === "mov" ? "video/quicktime" : "video/mp4";

      return (
        <div className="video-container">
          <video
            controls
            poster={item.thumbnail}
            className="detail-media"
            playsInline
            preload="none"
          >
            <source src={item.url} type={videoType} />
            Your browser does not support the video tag.
          </video>
        </div>
      );
    }

    return (
      <img
        src={item.url}
        alt={item.alt || `${projectTitle} detail ${index + 1}`}
        className="detail-media"
        loading="lazy"
        decoding="async"
        fetchPriority="low"
      />
    );
  };

  return (
    <div className="design-portfolio-container">
      <div className="design-portfolio-header">
        <h2>Fashion Design</h2>
        <p>
          Custom garments, upcycled construction, collaborative pieces, and
          Both Rows design work. Project videos load only when details are
          opened so visitors can scan the work faster.
        </p>
        <a
          href="https://www.showbothrows.com"
          target="_blank"
          rel="noopener noreferrer"
          className="both-rows-link"
        >
          See more at ShowBothRows.com
        </a>
        <div className="category-buttons">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-btn ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="projects-grid">
        {filteredProjects.map((project) => (
          <article key={project.id} className="project-card">
            <div className="project-image-container">
              <img 
                src={project.mainImage} 
                alt={project.title} 
                className="project-image"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
              <div className="project-overlay">
                <div className="project-meta">
                  <span className="project-category">{project.category}</span>
                  <span className="project-year">{project.year}</span>
                </div>
              </div>
            </div>
            
            <div className="project-content">
              <div className="project-header">
                <h2 className="project-title">{project.title}</h2>
                <p className="project-description">{project.description}</p>
              </div>
              
              <div className="media-toggle-section">
                <button 
                  className="toggle-media-btn"
                  onClick={() => toggleProjectExpansion(project.id)}
                  aria-expanded={expandedProjects[project.id] || false}
                >
                  {expandedProjects[project.id] ? 'Show Less' : `View Details (${project.detailMedia.length} items)`}
                  <span className={`arrow ${expandedProjects[project.id] ? 'expanded' : ''}`}>▼</span>
                </button>
                
                {expandedProjects[project.id] && (
                  <div className="project-details-expanded">
                    <div className="project-specifics">
                      <div className="spec-item">
                        <h4>Materials</h4>
                        <p>{project.materials}</p>
                      </div>
                      <div className="spec-item">
                        <h4>Process</h4>
                        <p>{project.process}</p>
                      </div>
                      <div className="spec-item">
                        <h4>Details</h4>
                        <ul>
                          {project.details.map((detail, index) => (
                            <li key={index}>{detail}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    
                    <div className="project-detail-media">
                      {project.detailMedia.map((media, index) => (
                        <MediaItem
                          key={index}
                          item={media}
                          projectTitle={project.title}
                          index={index}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default DesignPortfolio;
